import { CommandParser } from '../client/parser';
import { ArrayReply, BlobStringReply, NumberReply, UnwrapReply, Command } from '../RESP/types';
import { RedisVariadicArgument } from './generic-transformers';

export default {
  IS_READ_ONLY: true,
  parseCommand(parser: CommandParser, channels?: RedisVariadicArgument) {
    parser.push('PUBSUB', 'NUMSUB');

    if (channels) {
      parser.pushVariadic(channels);
    }
  },
  /**
   * Transforms the PUBSUB NUMSUB reply into a record of channel name to subscriber count
   *
   * @param rawReply - The raw reply from Redis
   * @returns Record mapping channel names to their subscriber counts
   */
  transformReply(rawReply: UnwrapReply<ArrayReply<BlobStringReply | NumberReply>>) {
    const reply: Record<string, number> = {};
    let i = 0;
    while (i < rawReply.length) {
      reply[rawReply[i++].toString()] = Number(rawReply[i++]);
    }

    return reply as unknown as Record<string, NumberReply>;
  }
} as const satisfies Command;
